import React, { Fragment } from 'react';
import { BreadcrumbContainer } from 'app/layout/Menu/AppBreadcrumb/AppBreadcrumb.styles';
import { Icon, IconName } from '@orbita-ui/core';
import { nanoid } from 'nanoid';

interface CustomBreadcrumbProps {
  icon: IconName;
  items: string[];
  lastItem: string;
}

export const CustomBreadcrumb: React.FC<CustomBreadcrumbProps> = ({ icon, items, lastItem }) => {
  return (
    <BreadcrumbContainer>
      <div className="bc-container">
        <Icon className="main" name={icon} />
        <Icon name="ChevronRightIcon" />
        {items.map((item) => (
          <Fragment key={nanoid()}>
            <p>{item}</p>
            <Icon name="ChevronRightIcon" />
          </Fragment>
        ))}
        <p className="last">{lastItem}</p>
      </div>
    </BreadcrumbContainer>
  );
};